import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCursorPosition from 'react-cursor-position';
import Rating from 'react-rating';
import Stars from '../stars/Stars'

import './percentageStars.scss';

class PercentageStars extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
     width: 1
    };
  }

  handleClick = (val) => {
    const { type, id } = this.props;
    this.props.onAsyncSubmitVote(id, type, val );
  }

  handlePositionChange = (val) => {
     if (val.elementDimensions) {
     this.props.setPosition(val.position.x)
      this.setState({width: val.elementDimensions.width})
     }
  }

  render() {
    const { canVote, average, numberOfVotes, position, title } = this.props;

    let score = position && canVote ? (position.toFixed(2) / this.state.width * 10 * 1.1).toFixed(1) : (average / 10).toFixed(1);
    if (score >= 10) {
      score = 10;  
    } else if (score < 0) {
      score = 0;
    }


    return (
      <div>
        <span className="percentage-stars-title">{title}</span>
        <div className="percentage-stars-container">
          <span className="percentage-stars">
            <ReactCursorPosition onPositionChanged={this.handlePositionChange} isActivatedOnTouch>
              <Stars
                placeholderColor="#b9b9b9"
                starColor="#eb8736"
                numberOfElements={5}
                onClick={this.handleClick}
                canVote={canVote}
                average={average}
                numberOfVotes={numberOfVotes}
                setPosition={this.props.setPosition}
                max={100}
              />
            </ReactCursorPosition>
          </span>
          <span className="percentage-stars-score">
            <span className='percentage-stars-score-value'>{score}</span> /10
          </span>
        </div>
        <div className="percentage-stars-votes">({numberOfVotes} {`${numberOfVotes  === 1 ? 'αξιολογήση' : 'αξιολογήσεις'}`})</div>
      </div>
    );
  }
}

export default PercentageStars;


// WEBPACK FOOTER //
// ./src/components/percentageStars/PercentageStars.jsx